module.exports = __webpack_public_path__ + "img/GAME_MARBLES.8b43e2fb.png";